import React, { useEffect, useRef } from 'react'
import useExcelDownload from '../../../hook/useExelDownload'

function DICPopup_Coral(props) {
    const { title, data } = props?.data
    const downloadExcel = useExcelDownload()

    const handleDownload = () => {
        const flatData = data?.map((x, index) => ({
            "Sr.No": index + 1,
            "Vin Number": x?.vehicleId,
            "City": x?.DLR_ORG_CITY,
            "Vehicle Registration Number": x?.vehicle_registration_number,
            "Last Fault Occurring Timestamp": x?.last_fault_occurring_timestamp,
        }))
        downloadExcel(flatData, title || "Real Time Summary")
    }

    return (
        <div>
            <div id="myModal_coral" className="modal fade" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title text-capitalize">{title}</h4>
                            <button type="button" className="close" data-dismiss="modal">
                                &times;
                            </button>
                        </div>
                        <div className="modal-body" style={{ overflowY: "scroll", height: "350px", }}>
                            <table className="table table-striped">
                                <thead style={{ backgroundColor: "#358696", color: "#fff", position: "sticky", zIndex: 1, top: "-17px" }}>
                                    <tr>
                                        <th scope="col">Sr.No</th>
                                        <th scope="col">Vin Number</th>
                                        <th scope="col">City</th>
                                        <th scope="col">Vehicle Registration Number</th>
                                        <th scope="col">Last Fault Occurring Timestamp</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data?.map((x, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td scope="row">{index + 1}</td>
                                                    <td scope="row" className="hand_geture" data-dismiss="modal" onClick={() => props.singleVinSelected(x?.vehicleId)}>{x?.vehicleId}</td>
                                                    <td scope="row">{x?.DLR_ORG_CITY}</td>
                                                    <td scope="row">{x?.vehicle_registration_number}</td>
                                                    <td scope="row">{x?.last_fault_occurring_timestamp}</td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={handleDownload}>
                                DOWNLOAD
                            </button>
                            <button type="button" className="btn btn-default" data-dismiss="modal" >
                                CLOSE
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DICPopup_Coral

